import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private static translateService: TranslateService;

  constructor(private translate: TranslateService) {
    TranslationService.translateService = translate;
  }

  public static getTranslateService(): TranslateService {
    return TranslationService.translateService;
  }
}
